import React from 'react';
import Typography from '@mui/material/Typography';

CText.defaultProps = {
    color: '333333',
    cursor: 'inehrit',
    variant: 'body1',
    component: null,
    noWrap: false,
    style: {},
};

export default function CText(props) {
    return (
        <Typography
            variant={props.variant}
            component={props.component}
            noWrap={props.noWrap}
            color={props.color ? props.color : '#000000'}
            style={props.style}
        >
            {props.children}
        </Typography>
    );
}
